import * as React from 'react';
import styles from './index.less';
import { useParams } from 'umi';
import { connect } from 'dva';
import { Dispatch } from 'redux';
import { FI18n } from '@freelog/tools-lib';
import RecommendThemes from '@/components/FRecommendThemes';

interface SuccessProps {
  dispatch: Dispatch;
}

function Success({ dispatch }: SuccessProps) {
  const params = useParams<{ id: string }>();
  return (
    <div className={styles.wrapper}>
      <div className={styles.tip}>
        <i className={`freelog fl-icon-a-chenggongzhengqueduigou1 ${styles['tip-icon']}`} />
        <div className={styles['tip-text']}>
          {FI18n.i18nNext.tAuto('msg_nodecreatedsuccessfully')}
        </div>
      </div>

      <div className={styles.content}>
        <RecommendThemes nodeID={Number(params.id)} btn='force' />
      </div>
    </div>
  );
}

export default connect()(Success);
